export interface FirebaseConfig {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
}

export interface DidomiConfig {
    apiKey: string;
    noticeKey: string;
}

export interface EnvironmentConfig {
    env: string;
    name: string;
    idURL: string;
    boURL: string;
    apiURL: string;
    authURL: string;
    adyenEnv: string;
    adyenClientKey: string;
    cdnURL: string;
    domain: string;
    googleMapKey: string;
    appVersion?: string;
    firebase: FirebaseConfig;
    didomi: DidomiConfig;
    isDev: boolean;
    isStaging: boolean;
    isProduction: boolean;
}

const currentEnv: EnvironmentConfig = {
    env: process.env.REACT_APP_ENVIRONMENT,
    name: process.env.NODE_ENV,
    idURL: process.env.REACT_APP_ID_API_URL,
    boURL: process.env.REACT_APP_BO_URL,
    apiURL: process.env.REACT_APP_BASE_API_URL,
    authURL: process.env.REACT_APP_AUTH_URL,
    adyenEnv: process.env.REACT_APP_ADYEN_ENVIRONMENT,
    adyenClientKey: process.env.REACT_APP_ADYEN_CLIENT_KEY,
    cdnURL: process.env.REACT_APP_CDN_URL,
    domain: process.env.REACT_APP_DOMAIN,
    googleMapKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
    appVersion: process.env.REACT_APP_VERSION,
    firebase: {
        apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
        projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
        appId: process.env.REACT_APP_FIREBASE_APPID,
        measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID,
    },
    didomi: {
        apiKey: process.env.REACT_APP_DIDOMI_API_KEY,
        noticeKey: process.env.REACT_APP_DIDOMI_NOTICE_KEY,
    },
    isDev: process.env.REACT_APP_ENVIRONMENT === 'development',
    isStaging: process.env.REACT_APP_ENVIRONMENT === 'staging',
    isProduction: process.env.REACT_APP_ENVIRONMENT === 'production',
};

const envConfig = {
    currentEnv,
};

export default envConfig;
